import { CloudCommand } from "../types.js";

export const searchContacts: CloudCommand = {
    action: "CONTACT/SEARCH",
    commandName: "contacts.searchContacts",
    buildPayload: ({ params }) => {
        const { onlyConnections, keywords } = (params ?? {}) as { onlyConnections?: boolean; keywords?: string };
        return { onlyConnections, keywords };
    },
};
